import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
const templates = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/dev-profile.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/dev-profile.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/dev-profile.jpg-wvc-sizes",
  alt: "DevProfile",
  label: "DevProfile"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/juris-law.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/juris-law.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/juris-law.jpg-wvc-sizes",
  alt: "JurisLaw",
  label: "JurisLaw"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/voyage-travel.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/voyage-travel.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/voyage-travel.jpg-wvc-sizes",
  alt: "VoyageTravel",
  label: "VoyageTravel"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/tutor-edge.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/tutor-edge.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/tutor-edge.jpg-wvc-sizes",
  alt: "TutorEdge",
  label: "TutorEdge"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/smile-dent.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/smile-dent.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/smile-dent.jpg-wvc-sizes",
  alt: "SmileDent",
  label: "SmileDent"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/luxe-stay.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/luxe-stay.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/luxe-stay.jpg-wvc-sizes",
  alt: "LuxeStay",
  label: "LuxeStay"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/vine-essence.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/vine-essence.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/vine-essence.jpg-wvc-sizes",
  alt: "VineEssence",
  label: "VineEssence"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/crust-bake.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/crust-bake.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/crust-bake.jpg-wvc-sizes",
  alt: "CrustBake",
  label: "CrustBake"
}];
function TemplateCard({
  src,
  srcset,
  sizes,
  alt,
  label,
  index
}: {
  src: string;
  srcset: string;
  sizes: string;
  alt: string;
  label: string;
  index: number;
}) {
  const [hovered, setHovered] = useState(false);
  return <div data-index={index}>
      <div onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} className="h-[160px] md:h-[219px]" style={{
      maxWidth: "100%",
      marginBottom: "24px",
      border: "1px solid rgba(20, 21, 31, 0.14)",
      borderRadius: "16px",
      overflow: "hidden",
      position: "relative",
      cursor: "pointer"
    }}>
        <img src={src} data-wvc-srcset={srcset} data-wvc-sizes={sizes} alt={alt} className="w-full h-full" loading="lazy" style={{
        objectFit: "cover",
        display: "block"
      }} />
        <div style={{
        transition: "opacity 0.3s, visibility 0.3s",
        opacity: hovered ? 1 : 0,
        visibility: hovered ? "visible" : "hidden",
        borderRadius: "16px",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(20, 21, 31, 0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
          <Link to="#" style={{
          width: "128px",
          height: "36px",
          textAlign: "center",
          fontSize: "14px",
          fontWeight: 400,
          borderRadius: "8px",
          backgroundColor: "rgb(255, 255, 255)",
          lineHeight: "33px",
          textDecoration: "none",
          color: "rgb(0, 0, 0)",
          fontFamily: '"Evergrow Sans", sans-serif',
          display: "block"
        }}>
            View template
          </Link>
        </div>
      </div>
      <h3 style={{
      color: "rgb(255, 255, 255)",
      fontFamily: '"Evergrow Sans", sans-serif',
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
      border: "0px none rgb(255, 255, 255)",
      animation: "none 0s ease 0s 1 normal none running"
    }}>
        {label}
      </h3>
    </div>;
}
export default function CustomizableWebsiteTemplates() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className={`w-full transition-all duration-700 ease-out ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
    padding: "0 10px"
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        .cards-inner-container::before {
          content: "";
          width: 953px;
          position: absolute;
          height: 209px;
          opacity: 0.5;
          background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(51,57,241,0.5) 50%, rgba(255,255,255,0) 100%);
          filter: blur(100px);
          right: 0px;
          top: 0px;
          display: block;
          z-index: 99;
          pointer-events: none;
        }
      `}</style>
      <div className="cards-inner-container" style={{
      backgroundColor: "rgb(20, 21, 31)",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      color: "rgb(20, 21, 31)",
      fontFamily: '"Evergrow Sans", "Inter", sans-serif',
      borderRadius: "28px",
      paddingBottom: "80px",
      animation: "none 0s ease 0s 1 normal none running",
      position: "relative"
    }} className="pt-[40px] md:pt-[80px]">
        <div className="page-container">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 md:gap-10" style={{
          flexWrap: "wrap"
        }}>
            <h2 style={{
            color: "rgb(255, 255, 255)",
            fontFamily: '"Evergrow Sans", "Inter", sans-serif',
            fontSize: "clamp(28px, 6vw, 40px)",
            fontWeight: 700,
            lineHeight: "1.3",
            border: "0px none rgb(255, 255, 255)",
            animation: "none 0s ease 0s 1 normal none running",
            margin: 0,
            flex: "1 1 auto"
          }} className="!font-medium max-w-2xl">Start from a template, end with your brand.</h2>
            <div style={{
            alignSelf: "flex-start",
            position: "relative",
            zIndex: 999
          }} className="md:self-end">
              <Link to="#" style={{
              color: "rgb(0, 0, 0)",
              fontFamily: '"Evergrow Sans", "Inter", sans-serif',
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "20px",
              backgroundColor: "rgb(255, 255, 255)",
              borderRadius: "8px",
              border: "1px solid rgb(0, 0, 0)",
              padding: "12px 18px",
              textAlign: "center",
              animation: "none 0s ease 0s 1 normal none running",
              textDecoration: "none",
              display: "inline-block",
              whiteSpace: "nowrap",
              transition: "opacity 0.2s"
            }} onMouseEnter={e => e.currentTarget.style.opacity = "0.8"} onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
                Website Templates
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-[32px_16px] md:gap-[64px_24px]" style={{
          paddingTop: "80px"
        }}>
            {templates.map((template, index) => <TemplateCard key={template.label} src={template.src} srcset={template.srcset} sizes={template.sizes} alt={template.alt} label={template.label} index={index} />)}
          </div>
        </div>
      </div>
    </section>;
}